module.exports = __webpack_public_path__ + "img/rule_of_thirds_splash.9d2638e9.jpg";